import { useQuery, UseQueryResult } from "@tanstack/react-query";
import UnReadCountResponse from "../../../models/API/responseModels/unreadCountResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";

function useUnreadCount(): UseQueryResult<UnReadCountResponse> {
  const { authState } = useOktaAuth();
  const { dispatch } = useContext(ApplicationState);
  return useQuery({
    queryKey: ["unreadCount"],
    queryFn: () =>
      axiosInstance
        .get("v1/notifications/unread-counts", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => {
          dispatch({
            type: "SET_NOTIFICATION_COUNT",
            payload: res?.data?.unreadCounts ?? 0,
          });
          return res.data;
        }),
    enabled: !!authState?.accessToken?.accessToken,
    staleTime: Infinity,
  });
}

export default useUnreadCount;
